import { createRouter, createWebHistory } from 'vue-router'

import HomePage from '@/components/HomePage.vue'
import SobrePage from '@/pages/SobrePage.vue'
import JogosPage from '@/pages/JogosPage.vue'
import DetalheJogo from "@/pages/DetalheJogo.vue"
import LinksPage from "@/pages/LinksPage.vue"

import RenegadoPrivacyPolicy from '@/pages/RenegadoPrivacyPolicy.vue'
import DioroomPrivacyPolicy from '@/pages/DioroomPrivacyPolicy.vue'
import UnderConstruction from '@/pages/UnderConstruction.vue'
import DioroomPreRegisterTerms from '@/pages/DioroomPreRegisterTerms.vue'

import iosIcon from '@/assets/ios/favicon-96x96.png'
import androidIcon from '@/assets/android/favicon-96x96.png'
import desktopIcon from '@/assets/desktop/favicon-96x96.png'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { title: 'Black Paladins', icon: desktopIcon },
  },
  {
    path: '/projects',
    name: 'Projects',
    component: JogosPage,
    meta: { title: 'Projetos', icon: desktopIcon, hidden: true },
  },
  {
    path: '/sobre',
    name: 'Sobre',
    component: SobrePage,
    meta: { title: 'Sobre Nós', icon: desktopIcon, hidden: true},
  },
  {
    path: '/links',
    name: 'Links',
    component: LinksPage,
    meta: { hideLayout: true }
  },
  {
    path: "/projects/:name",
    name: ':name',
    component: DetalheJogo,
    props: true,
    beforeEnter: (to) => {
      document.title = `${to.params.name} | Black Paladins`
    },
    meta: {hidden: true }
  },
  {
    path: '/renegado-privacy-policy',
    name: 'RenegadoPrivacyPolicy',
    component: RenegadoPrivacyPolicy,
    meta: { title: 'Renegado - Privacy Policy', icon: desktopIcon},
  },
  {
    path: '/dioroom-privacy-policy',
    name: 'DioroomPrivacyPolicy',
    component: DioroomPrivacyPolicy,
    meta: { title: 'Dioroom - Privacy Policy', icon: desktopIcon},
  },
  {
    path: '/dioroom-pre-register-terms',
    name: 'DioroomPreRegisterTerms',
    component: DioroomPreRegisterTerms,
    meta: { title: 'Dioroom Pre-Register Terms', icon: desktopIcon},
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: UnderConstruction,
    meta: { title: 'Page Not Found', icon: desktopIcon },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const isMobile = window.innerWidth <= 800
          const headerOffset = isMobile ? 70 : 80

          const element = document.querySelector(to.hash)

          if (element) {
            const y =
              element.getBoundingClientRect().top +
              window.scrollY -
              headerOffset

            resolve({
              top: y,
              behavior: "smooth"
            })
          } else {
            resolve({ top: 0 })
          }
        }, 100)
      })
    }

    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
   // 🔒 BLOQUEIO DE ROTAS HIDDEN
  if (to.meta?.hidden) {
    return next('/:pathMatch(.*)*') // ou '/404'
  }
  if (to.meta.title) document.title = to.meta.title

  let icon = desktopIcon
  if (navigator.userAgent.match(/iPhone|iPad|iPod/)) icon = iosIcon
  else if (navigator.userAgent.match(/Android/)) icon = androidIcon

  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement('link')

  link.rel = 'icon'
  link.href = icon

  if (!document.head.contains(link)) {
    document.head.appendChild(link)
  }

  next()
})

export default router